import React from "react";

import { templates } from "@reactivated";

import { ProductReviewsSSR } from "../apps/reviews/ProductReviewsSSR";

export const Template = (
    props: templates.ProductReviewsTemplate,
): React.JSX.Element => {
    return <ProductReviewsSSR {...props} isCollapsedView={true} />;
};
